import { Moment } from "moment";
import * as moment from "moment";

class DateHelper {
  public static FormatDate(dateString: string) {
    return new Date(dateString).toLocaleDateString(undefined, this.DateFormat);
  }

  public static GetDaysAgo(dateString: string) {
    const date = new Date(dateString);
    const daysAgo = Math.floor((new Date().getTime() - date.getTime()) / 86400000);
    return daysAgo + (daysAgo === 1 ? ' day' : ' days') + ' ago';
  }
  

  private static DateFormat = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: false,
  };
}

export default DateHelper;


export const dateIsLessThan24HoursAgo = (date: Moment) => {
  const twentyFourHoursAgo = moment(new Date()).subtract(24, 'hours');

  return date.isAfter(twentyFourHoursAgo);
}


// WEBPACK FOOTER //
// ./src/modules/shared/helpers/DateHelper.tsx